

















import { PropType, defineComponent, onMounted, ref } from '@vue/composition-api';
import { Message, ReportData } from '../../../dataType';
import Card from '../Card.vue';
import AssigneeReport from './assignee-report-card.vue';
import SprintReport from './sprint-report-card.vue';
import ProjectIdReport from './project-id-report-card.vue';
import DepartmentReport from './department-report-card.vue';
import RiskReport from './risk-report-card.vue';
import SprintProgress from './sprint-progress-card.vue';
import NoReport from './no-report-card.vue';
import KnowledgeQa from '../search-assistant/card.vue';
import { useMessageInteract } from '../../../hooks/useMessageInteract';

export default defineComponent({
  components: {
    Card,
    assignee: AssigneeReport,
    sprint: SprintReport,
    projectId: ProjectIdReport,
    department: DepartmentReport,
    risk: RiskReport,
    SprintProgress: SprintProgress,
    NoReport,
    KnowledgeQa: KnowledgeQa
  },
  props: {
    message: {
      type: Object as PropType<Message<ReportData<any>>>,
      required: true
    }
  },
  setup(props) {
    const getReportComponent = () => {
      if (props.message.content.report.reportData.error) {
        return 'NoReport';
      }
      if (props.message.content.report.base.intentCode === 'risk' && props.message.content.report.reportType === 'sprint') {
        return 'risk';
      }
      if (props.message.content.report.base.intentCode === 'progress' && props.message.content.report.reportType === 'sprint') {
        return 'SprintProgress';
      }

      if (props.message.content.report.base.intentCode === 'knowledge_qa') {
        return 'KnowledgeQa';
      }
      return props.message.content.report.reportType;
    };
    const { isDisabled } = useMessageInteract(props.message);
    const component = getReportComponent();
    const showGuide = ref(false);

    onMounted(() => {
                       
      showGuide.value = !!component && component !== 'NoReport' && !isDisabled.value;
               
    });
    return {
      component,
      showGuide
    };
  }
});
